module.exports = __webpack_public_path__ + "static/media/HFDI.4a0ef478.png";